var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_16298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_16298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33335 12.4997H10.6667V11.1663H5.33335V12.4997ZM5.33335 9.83301H10.6667V8.49967H5.33335V9.83301ZM4.00002 15.1663C3.63335 15.1663 3.31946 15.0358 3.05835 14.7747C2.79724 14.5136 2.66669 14.1997 2.66669 13.833V3.16634C2.66669 2.79967 2.79724 2.48579 3.05835 2.22467C3.31946 1.96356 3.63335 1.83301 4.00002 1.83301H9.33335L13.3334 5.83301V13.833C13.3334 14.1997 13.2028 14.5136 12.9417 14.7747C12.6806 15.0358 12.3667 15.1663 12 15.1663H4.00002ZM8.66669 6.49967V3.16634H4.00002V13.833H12V6.49967H8.66669Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteActivity);
export default __webpack_public_path__ + "static/media/note_activity.2ea2a58f98f7abf084001c98cc4a3adb.svg";
export { ForwardRef as ReactComponent };